export default __webpack_public_path__ + "static/media/icon-error.72c4c5ff.svg";